import { useState } from 'react'
import CookieBar from '../organisms/CookieBar'
import HeaderBarEmployee from '../organisms/HeaderBarEmployee'

export default function NoFooterLayout({ children }: any) {
  const [spacerHeight, setSpacerHeight] = useState(0)
  return (
    <>
      <HeaderBarEmployee setSpacerHeight={setSpacerHeight} />
      <div style={{ height: spacerHeight }} />
      {children}
      <CookieBar />
    </>
  )
}
